@if (isInternalUser()) {
  <div class="c-global-alert c-global-alert--member">
    <div class="l-container">
      @if (member()) {
        <p class="u-align-center">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          {{ 'ALERT.current_member_data' | translate }}
          <strong id="member_name">{{ member()?.personalInformation?.firstName }} {{ member()?.personalInformation?.lastName }}</strong>
          ({{ member()?.personalInformation?.inss }})
        </p>
      }
      @if (!member()) {
        <p class="u-align-center">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          {{ 'ALERT.no_member_selected' | translate }}
        </p>
      }
    </div>
  </div>
}
